import { defineStore } from 'pinia';
import type { User } from '@/types/models/common/user.d';
import { type Ref, ref } from 'vue';
import { useI18n } from '#imports';

export const useUsersStore = defineStore('users', () => {
  const users: Ref<User[]> = ref([]);
  const { t } = useI18n();

  const getUserName = (id: number): string => {
    const result = users.value.find((user: User) => user.id === id);
    return result !== undefined && result.name !== '' ? result.name : t('common.deleted-user');
  };

  const setUsers = (data: User[]) => {
    users.value = data;
  };

  return {
    users,
    getUserName,
    setUsers,
  };
});
